var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 1.6665H8.33329C7.41413 1.6665 6.66663 2.414 6.66663 3.33317V6.6665H3.33329C2.41413 6.6665 1.66663 7.414 1.66663 8.33317V16.6665C1.66663 17.5857 2.41413 18.3332 3.33329 18.3332H11.6666C12.5858 18.3332 13.3333 17.5857 13.3333 16.6665V13.3332H16.6666C17.5858 13.3332 18.3333 12.5857 18.3333 11.6665V3.33317C18.3333 2.414 17.5858 1.6665 16.6666 1.6665ZM3.33329 16.6665V8.33317H11.6666L11.6683 16.6665H3.33329ZM16.6666 11.6665H13.3333V8.33317C13.3333 7.414 12.5858 6.6665 11.6666 6.6665H8.33329V3.33317H16.6666V11.6665Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H10V11.6667H5V10ZM5 13.3333H10V15H5V13.3333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1d6703ec51e23b7d8150ffa017a73201.svg";
export { ForwardRef as ReactComponent };